if (!window.customElements.get("variant-description")) {
    class VariantDescription extends HTMLElement {
        constructor() {
            super();
            this.onVariantChanged = this.onVariantChanged.bind(this);
        }

        connectedCallback() {
            document.addEventListener("variant:change", this.onVariantChanged);
        }

        disconnectedCallback() {
            document.removeEventListener(
                "variant:change",
                this.onVariantChanged,
            );
        }

        onVariantChanged(event) {
            if (event.detail.product?.handle !== this.getAttribute("handle")) {
                return;
            }

            const variantId = event.detail.variant?.id;
            const target =
                (variantId &&
                    this.querySelector(
                        `[data-variant-description="${variantId}"]`,
                    )) ||
                this.querySelector('[data-variant-description="default"]');

            if (!target) {
                return;
            }

            this.querySelectorAll("[data-variant-description]").forEach(
                (description) => {
                    description.toggleAttribute(
                        "hidden",
                        description !== target,
                    );
                },
            );
        }
    }

    window.customElements.define("variant-description", VariantDescription);
}
